import script from "./burtonDashboard.vue?vue&type=script&setup=true&lang=js"
export * from "./burtonDashboard.vue?vue&type=script&setup=true&lang=js"

import "./burtonDashboard.vue?vue&type=style&index=0&id=0290a2e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0290a2e2"]])

export default __exports__